export default {
    save(key, value) {
        let projectName = process.env.VUE_APP_PROJECT_NAME
        localStorage.setItem(projectName + "_" + key, JSON.stringify(value))
    },
    get(key, defaultValue = {}) {
        let projectName = process.env.VUE_APP_PROJECT_NAME
        try {
            return JSON.parse(localStorage.getItem(projectName + "_" + key)) || defaultValue
        } catch (err) {
            return defaultValue
        }
    },
    remove(key) {
        let projectName = process.env.VUE_APP_PROJECT_NAME
        localStorage.removeItem(projectName + "_" + key)
    },
    clear() {
        localStorage.clear()
    }
}
